export default class ArrayUtil {
    find(array, callback, initial, convert) {
        convert = convert || ((current) => current);
        
        for (let index = 0; index < array.length; ++index) {
            if (callback(array[index], index)) {
                return convert(array[index], index);
            }
        }

        return initial === null ? null : initial;
    }

    remove(array, callback) {
        for (let index = 0; index < array.length; ++index) {
            if (callback(array[index], index)) {
                array = array.slice();
                array.splice(index, 1);
                break;
            }
        }

        return array;
    }

    groupBy(array, callback) {
        let groups = {};
        
        array.forEach((current) => {
            let key = callback(current);
            groups[key] = groups[key] || {
                key,
                values: []
            };
            groups[key].values.push(current);
        });

        return Object.keys(groups).map((key) => {
            return groups[key];
        });
    }

    skip(array, count) {
        return array.slice(count);
    }

    take(array, count) {
        return array.slice(0, count);
    }

    unique(array, callback) {
        let set = {};
        let result = [];
        
        for (let index = 0; index < array.length; ++index) {
            let key = JSON.stringify(callback(array[index]));
            if (!set[key]) {
                set[key] = true;
                result.push(array[index]);
            }
        }

        return result;
    }

    flatten(array) {
        return Array.prototype.concat.apply([], array);
    }
}



// WEBPACK FOOTER //
// ./src/application/util/array.util.js